<template>
  <div class="main-container">
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
   <div> 
    <!-- Author: Siddhartha
      Date: 17/01/2020
    Issue Description: payroll Incometax children components-->
   <!--  <breadcrumb :list="breadcrumbList" />  -->
   <!--  <under-construction></under-construction> -->
    <div class="margintop-16" />
    <tl-header type="h1">IT Declaration: {{PlanName}}</tl-header>
    <div class=" lineheight"></div>
    <!-- Section 1 -->
    <div class="container-fluid" id="example">
        <div class="row">
            <div class="col-3 first">
                <div @click="nothing">
                    <div class="img-user">
                    <img src="@/assets/user.svg" class="oval" />
                    </div>
                              
                    <div class="month">
                        <!-- <div class="employee-fullname">{{` ${employeeObj.first_name} ${employeeObj.last_name} `}} </div>
                        <div class="employee-code"> {{ `${employeeObj.code}`}} </div> -->
                        <div class="employee-fullname"> {{first_name}} {{last_name}}</div>
                        <div class="employee-code"> {{code}} </div>
                        <div class="salary-perks">Salary and Perks:</div>
                        <div class="salary-ctc"> ₹ {{ctc}}</div>
                        <div class="view-salary-breakup" @click="showPopupSalaryPerks = !showPopupSalaryPerks">View Salary Breakup</div>
                    </div>
                </div>
            </div>
            <div class="col-5 middle">
                <div class="row">
                    <div class="col-6">
                        <div class="regime-title">Old Regime</div>
                    </div>
                    <div class="col-6">
                        <!-- <div>
                            <div class="badget-custom">
                                <span>Maximum Benefit</span>
                            </div>
                            <img class="icon-i" src="@/assets/info-2.svg" alt />
                        </div> -->
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <div class="total-taxable-income">Total Taxable Income:</div>
                    </div>
                    <div class="col-6">
                        <div class="taxable-amount">
                                ₹ {{totalIncomeTax}}
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-6">
                        <div class="total-taxable-income">Annual Tax:</div>
                    </div>
                    <div class="col-6">
                        <div class="taxable-amount">
                                ₹ {{annualTax}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col custom-width-block-19"></div>
                    <div class="col custom-col">
                        <div class="view-salary-breakup" @click="showPopupTdsBreakupOldRegimePopup = !showPopupTdsBreakupOldRegimePopup">TDS Breakup</div>
                    </div>
                    <div class="col custom-col">
                        <div class="view-salary-breakup" @click="showPopupItDeclarationStatmentOldRegimePopup = !showPopupItDeclarationStatmentOldRegimePopup">View Salary Breakup</div>
                    </div>
                </div>
            </div>
            <div class="col-4 last">
            <div class="row">
                    <div class="col-6">
                        <div class="regime-title">New Regime</div>
                    </div>
                    <div class="col-6">
                        <!-- <div class="icon-move-right">
                            <img class="icon-i" src="@/assets/info-2.svg" alt />
                        </div> -->
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <div class="total-taxable-income">Total Taxable Income:</div>
                    </div>
                    <div class="col-6">
                        <div class="taxable-amount">
                                ₹ 0
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-6">
                        <div class="total-taxable-income">Annual Tax:</div>
                    </div>
                    <div class="col-6">
                        <div class="taxable-amount">
                                ₹ 0
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col custom-width-block-13"></div>
                    <div class="col custom-col">
                        <!-- <div class="view-salary-breakup" @click="showPopupTdsBreakupNewRegimePopup = !showPopupTdsBreakupNewRegimePopup">TDS Breakup</div> -->
                    </div>
                    <div class="col custom-col">
                        <!-- <div class="view-salary-breakup" @click="showPopupItDeclarationStatmentNewRegimePopup =!showPopupItDeclarationStatmentNewRegimePopup">View Salary Breakup</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end section 1 -->

    <!-- Section 2 -->
    <div class="container-fluid">
      <div class="row my-4">
        <div class="col-8">
          <div class="deduction-title">Deductions (₹)</div>
        </div>
        <div class="col-4" style="text-align: right;">
          <!-- <img
              class="search-icon-filter"
              src="@/assets/emp-dir-list.svg"
              v-on:click="seen = false"
              alt
            /><span class="line"></span
            ><img
              class="search-icon-filter"
              src="@/assets/emp-dir-grid.svg"
              v-on:click="seen = true"
              alt
            /> -->
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="block-deductions" @click="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Exemption Under Section 10</h4>
                  <span class="block-deductions-sub-title">HRA, LTA, Hostel Fee Allowance</span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div><br><br>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">0/200,000</span>
                <div class="progress-bar-blue"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="block-deductions" @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"> 
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Deductions Under 80C, 80D, 80E, 80U</h4>
                  <span class="block-deductions-sub-title">Mutual Funds, Insurance,NPS, PF, FD etc.</span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">72,000/235,000</span>
                <div class="progress-bar-blue">
                  <div class="progress-target"></div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="block-deductions" @click="showPopupDeductionUnderSectionSixteen = !showPopupDeductionUnderSectionSixteen">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Deductions Under Section 16</h4>
                  <span class="block-deductions-sub-title">PT, Standard Deduction</span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div><br><br>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">50,000</span>
                <div class="progress-bar-blue">
                  <div class="progress-target-full"></div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <!-- <div class="col-4">
          <div class="block-deductions" @click="showPopupExemptionUnderSectionSeventeen = !showPopupExemptionUnderSectionSeventeen">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Exemption Under Section 17</h4>
                  <span class="block-deductions-sub-title">Gifts, Food Coupons, Telephone Reimbursement</span>
              </div>
              <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div>
            </div><br><br>
            <div class="row mt-3">
              <div class="col-12">
                <span class="amount-deduction">0/200,000</span>
                <div class="progress-bar-blue"></div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- end section 2 -->
    <!-- Section 3 -->
    <div class="container-fluid">
      <div class="row my-4">
        <div class="col-12">
          <div class="deduction-title">Income (₹)</div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="block-deductions" @click="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Income from Previous Employer</h4>
                  <span class="block-deductions-sub-title">Mandatory when date of Joining is after Cutoff cycle for March </span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div><br>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">0</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="block-deductions" @click="showPopupOtherIncome = !showPopupOtherIncome">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Other Income</h4>
                  <span class="block-deductions-sub-title">Apart from Salary like FD interest, Saving Account interest</span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div><br>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">0</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="block-deductions" @click="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty">
            <div class="row">
              <div class="col-9">
                  <h4 class="block-deductions-title">Income/Loss from Housing Property</h4>
                  <span class="block-deductions-sub-title">Interest on housing loan, Income/loss on Let-out Property</span>
              </div>
              <!-- <div class="col-3 deduction-img">
                <img class="icon-i" src="@/assets/info-2.svg" alt />
              </div> -->
            </div><br>
            <div class="row mt-3">
              <!-- <div class="col-12">
                <span class="amount-deduction">0</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 3 -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="backpreviouspage" />
          <btn  text="Save Plan" type="primary" @click="saveplan"/>
        </btn-grp>
      </template>
    </bottom-action-container>
    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"
      :message="`${logMessage}`">
      
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message"></span>
        </div>
      </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>
          <div class="popup-btn-group margintop-32 marginright">
            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To IT Declaration</button>
          </div>
        </template>
    </pop-up-message>

    <!-- Popup Message show click on Save paln button -->
    <!-- <pop-up-message
            v-if="showConfirmationMsg"
            :popupHeaderMessage="'Select Tax Regime'"
            :message="`Select one of the tax regimes for which you would like to save this plan.`"
            @back="cancelEvent"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn
              text="Cancel"
              type="secondary"
              @click="cancelEvent"
         />
          <popup-btn text="Save" type="primary" @click="saveTaxRegime" />
        </btn-grp>
      </template>
    </pop-up-message> -->
    <!-- End popup code here  -->

    <!-- Another Popup Message show click on Save paln button -->
    <div class="modal" v-if="showConfirmationMsg">

      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Select Tax Regime</span>
        </div>
        <div style="padding: 30px;">
          <div class="message-text animated fadeInRight">Select one of the tax regimes for which you would like to save this plan.</div>
          <div class="radio-btn">
            <tl-radio
              name="regime"
              label="Old Tax Regime"
              id="oldregime"
              value="oldregime"
              v-model="data2.regime_type"
            /> 
              <!-- <span class="badget-custom-popup-title">Maximum Benefit</span> -->
            <br/>
            <tl-radio
              name="regime"
              label="New Tax Regime"
              id="newregime"
              value="newregime"
              v-model="data2.regime_type"
            />
          </div>
        </div>
          <div class="popup-btns animated fadeIn">
            <btn-grp>
              <popup-btn
                  text="Cancel"
                  type="secondary"
                  @click="cancelEvent"
            />
              <popup-btn text="Save" type="primary" @click="saveTaxRegime" />
            </btn-grp>
          </div>
      </div>
    </div>
    <!-- End here -->


    <pop-up-window
        v-if="showPopupSalaryPerks"
        @back="showPopupSalaryPerks = !showPopupSalaryPerks"
        header="Salary and Perks"
        >
          <template v-slot:content>
            <salary-perks 
            @back="showPopupSalaryPerks = !showPopupSalaryPerks"
            :salaryPerk="salaryPerk"
            :itSheet="itSheet"
            >
            </salary-perks>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupTdsBreakupOldRegimePopup"
        @back="showPopupTdsBreakupOldRegimePopup = !showPopupTdsBreakupOldRegimePopup"
        header="TDS Breakup"
        >
          <template v-slot:content>
            <tds-breakup-old-regime-popup 
            @back="showPopupTdsBreakupOldRegimePopup = !showPopupTdsBreakupOldRegimePopup"
            :tds_breakup_and_taxable_income="tds_breakup_and_taxable_income"
            :itSheet="itSheet"
            >
            </tds-breakup-old-regime-popup>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupItDeclarationStatmentOldRegimePopup"
        @back="showPopupItDeclarationStatmentOldRegimePopup = !showPopupItDeclarationStatmentOldRegimePopup"
        header="IT Declaration Statment"
        >
          <template v-slot:content>
            <it-declaration-statment-old-regime-popup 
            @back="showPopupItDeclarationStatmentOldRegimePopup = !showPopupItDeclarationStatmentOldRegimePopup"
            :tds_breakup_and_taxable_income="tds_breakup_and_taxable_income"
            :itSheet="itSheet"
            >
            </it-declaration-statment-old-regime-popup>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupTdsBreakupNewRegimePopup"
        @back="showPopupTdsBreakupNewRegimePopup = !showPopupTdsBreakupNewRegimePopup"
        header="TDS Breakup"
        >
          <template v-slot:content>
            <tds-breakup-new-regime-popup 
            @back="showPopupTdsBreakupNewRegimePopup = !showPopupTdsBreakupNewRegimePopup"
            >
            </tds-breakup-new-regime-popup>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupItDeclarationStatmentNewRegimePopup"
        @back="showPopupItDeclarationStatmentNewRegimePopup = !showPopupItDeclarationStatmentNewRegimePopup"
        header="IT Declaration Statment"
        >
          <template v-slot:content>
            <it-declaration-statment-new-regime-popup 
            @back="showPopupItDeclarationStatmentNewRegimePopup = !showPopupItDeclarationStatmentNewRegimePopup"
            >
            </it-declaration-statment-new-regime-popup>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupExemptionUnderSectionDeduction"
        @back="changeHeaderTitle"
        :header="exemptionSection"
        >
          <template v-slot:content>
            <exemption-under-section-deduction @passPopupHeader="popupMessage"
            @back="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction"
            :section10="data2.exemption10"
            @section10update="section10update"
            >
            </exemption-under-section-deduction>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupDeductionUnderCdeu"
        @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
        header="Deduction Under Chapter VI A"
        >
          <template v-slot:content>
            <deduction-under-cdeu 
            @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
            :chapterVIA="data2.deductionsUnderChapterVIA"
            @chapterVIAupdate="chapterVIAupdate"
            >
            </deduction-under-cdeu>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupDeductionUnderSectionSixteen"
        @back="showPopupDeductionUnderSectionSixteen = !showPopupDeductionUnderSectionSixteen"
        header="Deduction Under Section 16A"
        >
          <template v-slot:content>
            <deduction-under-section-sixteen 
            @back="showPopupDeductionUnderSectionSixteen = !showPopupDeductionUnderSectionSixteen"
            :section16A="data2.deductionsUnderSection16"
            >
            </deduction-under-section-sixteen>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupExemptionUnderSectionSeventeen"
        @back="showPopupExemptionUnderSectionSeventeen = !showPopupExemptionUnderSectionSeventeen"
        header="Deduction Under Section 17"
        >
          <template v-slot:content>
            <exemption-under-section-seventeen 
            @back="showPopupExemptionUnderSectionSeventeen = !showPopupExemptionUnderSectionSeventeen"
              :section17="data2.exemption17"
              @section17update="section17update"
            >
            </exemption-under-section-seventeen>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupIncomeFromPreviousEmployer"
        @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
        
        header="Income From Previous Employer"
        
        >
          <template v-slot:content>
            <income-from-previous-employer 
            @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
            :previousEmploymentDetails="data2.previousEmploymentDetails"
            @previousDataUpdate="previousDataUpdate"
            >
            </income-from-previous-employer>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupOtherIncome"
        @back="showPopupOtherIncome = !showPopupOtherIncome"
        header="Other Income"
        >
          <template v-slot:content>
            <other-income
            @back="showPopupOtherIncome = !showPopupOtherIncome"
            :otherIncome="data2.otherIncome"
            @otherIncomeUpdate="otherIncomeUpdate"
            >
            </other-income>
         </template>
    </pop-up-window>
    <pop-up-window
        v-if="showPopupIncomeLossFromHousingProperty"
        @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
        header="Section 24A"
        >
          <template v-slot:content>
            <income-loss-from-housing-property
            @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                  :Section24="data2.section24"
                  @Section24Update="Section24Update"
            >
            </income-loss-from-housing-property>
         </template>
    </pop-up-window>
   </div>
   <dws-paylief-loading v-if="apiPending"></dws-paylief-loading>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import SalaryPerks from "./salaryPerks.vue";
import TdsBreakupOldRegimePopup from "./tdsBreakupOldRegimePopup.vue";
import ItDeclarationStatmentOldRegimePopup from "./itDeclarationStatmentOldRegimePopup.vue";
import TdsBreakupNewRegimePopup from "./tdsBreakupNewRegimePopup.vue";
import ItDeclarationStatmentNewRegimePopup from "./itDeclarationStatmentNewRegimePopup.vue";
import ExemptionUnderSectionDeduction from "./exemptionUnderSectionDeduction.vue";
import DeductionUnderCdeu from "./deductionsUnderCdeu.vue";
import DeductionUnderSectionSixteen from "./deductionUnderSectionSixteen.vue";
import ExemptionUnderSectionSeventeen from "./exemptionUnderSectionSeventeen.vue";
import IncomeFromPreviousEmployer from "./incomeFromPreviousEmployer";
import OtherIncome from "./otherIncome.vue";
import IncomeLossFromHousingProperty from "./incomeLossFromHousingProperty.vue";

export default {
  components: {
    SalaryPerks,
    TdsBreakupOldRegimePopup,
    ItDeclarationStatmentOldRegimePopup,
    TdsBreakupNewRegimePopup,
    ItDeclarationStatmentNewRegimePopup,
    ExemptionUnderSectionDeduction,
    DeductionUnderCdeu,
    DeductionUnderSectionSixteen,
    ExemptionUnderSectionSeventeen,
    IncomeFromPreviousEmployer,
    OtherIncome,
    IncomeLossFromHousingProperty
  },
  data() {
    return {
      toast:false,
      errmsg: "",
      apiPending: true,
      employeeObj: null,
      PlanName:null,
      showPopupSalaryPerks: false,
      showPopupTdsBreakupOldRegimePopup: false,
      showPopupItDeclarationStatmentOldRegimePopup: false,
      showPopupTdsBreakupNewRegimePopup: false,
      showPopupItDeclarationStatmentNewRegimePopup: false,
      showPopupExemptionUnderSectionDeduction: false,
      showPopupDeductionUnderCdeu: false,
      showPopupDeductionUnderSectionSixteen: false,
      showPopupExemptionUnderSectionSeventeen: false,
      showPopupIncomeFromPreviousEmployer: false,
      showPopupOtherIncome: false,
      showPopupIncomeLossFromHousingProperty: false,
      showConfirmationMsg: false,
      exemptionSection: "Exemption Under Section 10",
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: []
      },
      it_plan_id:"",
      employeeId:"",
      instance:{
        le_id:"",
        employee_id:"",
        financial_year:"",
        it_plan_id:"",
      },
      data2:{
      exemption10:[],
      exemption17:[],
      deductionsUnderSection16:[],
      deductionsUnderChapterVIA:[],
      section24:[],
      previousEmploymentDetails:{},
      otherIncome:[],
      le_id:"",
      employee_id:"",
      financial_year:"",
      plan_id:"",
      regime_type:"",
      },
      
      salaryPerk:[],
      tds_breakup_and_taxable_income:[],
      itSheet:[],
      first_name:"",
      last_name: "",
      ctc:"",
      code:"",
      totalIncomeTax:"",
      annualTax:"",
      showSuccessMsg: false,
      totalAmount_otherIncome:"",
      totalAmount_previousEmpDetails: "",
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
    };
  },
  computed: {
     ...mapState({
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
         }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
    
  },

  mounted() {
    this.salaryTableData = [];
    this.fetchRecord();
  },
  activated() {
    //this.fetchAllSalaryStructureData();
    this.salaryTableData = [];
    //this.setRecordData();  
    this.fetchRecord();
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data:"dashboard/payroll/incometax/setItData",  
      act_save_it_plan:"dashboard/payroll/incometax/createItData",
      act_fetch_plan_name:"dashboard/payroll/incometax/getPlanName",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

   async fetchRecord() {
      try {

        this.apiPending = true;
        this.it_plan_id = this.$route.query.it_plan_id;
        this.employeeId = this.$route.query.employee_id;
        let payload = {
          empId: this.employeeId,
          empLeId: this.le_id
        }
        let employeeDetail = await this.act_fetchEmpById(payload);
        let planDetails = await this.act_fetch_plan_name(this.it_plan_id);
        this.PlanName = planDetails.data.payload.plan_name;
        this.first_name = employeeDetail.data.payload.data.first_name;
        this.last_name = employeeDetail.data.payload.data.last_name;
        this.ctc = employeeDetail.data.payload.data.EmployeeSalarySetting[0].ctc;
        this.code = employeeDetail.data.payload.data.code;
        //console.log("Employee Details", employeeDetail.data.payload.data);
        this.instance.employee_id = this.employeeId;
        // let bodyParams = {};
        // let  data = await this.getOrgLeList({
        //   data: {
        //     ...bodyParams
        //   }
        // });
        // this.role = data.data.user.userRole;
        // if(this.role == "EMPLOYEE") {
        //   this.instance.financial_year= new Date().getFullYear();
        // } else {
        this.instance.financial_year = this.payrollYear;
        //}
        this.instance.it_plan_id = this.it_plan_id;
        this.instance.le_id = this.le_id;
        let res = await this.act_set_it_data(this.instance)

        if (res.status) {
          this.data2.regime_type = res.data.payload.regime_type && res.data.payload.regime_type;
          this.data2.exemption10 = res.data.payload.Exemption10;
          this.data2.exemption17 = res.data.payload.Exemption17;
          this.data2.deductionsUnderSection16 = res.data.payload.deductionsUnderSection16;
          this.data2.deductionsUnderChapterVIA = res.data.payload.deductionsUnderChapterVIA;
          //console.log("deductionsUnderChapterVIA---------->",this.data2.deductionsUnderChapterVIA)
          this.data2.section24 = res.data.payload.section24;
          this.data2.otherIncome = res.data.payload.otherIncome;
          this.data2.previousEmploymentDetails = res.data.payload.previousEmploymentDetails;
          // this.totalAmount_previousEmpDetails = this.data2.previousEmploymentDetails.nps.amount+
          //                                       this.data2.previousEmploymentDetails.pf.amount+
          //                                       this.data2.previousEmploymentDetails.pt.amount+
          //                                       this.data2.previousEmploymentDetails.salary_income.amount+
          //                                       this.data2.previousEmploymentDetails.tds.amount+
          //                                       this.data2.previousEmploymentDetails.vpf.amount;

          this.totalAmount_otherIncome = this.data2.otherIncome.reduce((total, i) => {
            total = total + i.planned;
            return total;
          }, 0)
          this.salaryPerk = res.data.payload.Salary;
          this.tds_breakup_and_taxable_income = res.data.payload.tds_breakup_and_taxable_income;
          this.itSheet = res.data.payload.itSheet;

          this.totalIncomeTax = this.itSheet[0].taxableIncome;
          this.annualTax = this.itSheet[0].totalTax;
          //console.log("TDS data show", this.tds_breakup_and_taxable_income);
          //console.log("IT sheet data ",this.itSheet);
        }
        setTimeout(() => {
          this.apiPending = false
        }, 2500); 
      } catch (error) {
        this.apiPending = false;
      }
    },

    backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: this.employeeId }
      });
    },
    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },
    section10update(Exemption10){
        this.showPopupExemptionUnderSectionDeduction=false;
       // //console.log("updated data ",Exemption10);
        this.data2.exemption10=Exemption10;


    },
    section17update(Exemption17){
        this.showPopupExemptionUnderSectionSeventeen=false;
        ////console.log("updated data Exemption17",Exemption17);
        this.data2.exemption17=Exemption17;


    },
    previousDataUpdate(previousEmpData){
        this.showPopupIncomeFromPreviousEmployer=false;
        ////console.log("updated data previousEmpData",previousEmpData);
        this.data2.previousEmploymentDetails=previousEmpData;


    },

    chapterVIAupdate(chapterData){
      this.showPopupDeductionUnderCdeu=false;
      //console.log("updated data chapter VI A",chapterData);
      this.data2.deductionsUnderChapterVIA=chapterData;
    },

    otherIncomeUpdate(otherIncomeList){
      this.showPopupOtherIncome=false;
      //console.log("updated data Other Income",otherIncomeList);
      this.data2.otherIncome=otherIncomeList;
    },
      Section24Update(Section24Update){
      this.showPopupIncomeLossFromHousingProperty=false;
      //console.log("updated data Other Income",Section24Update);
      this.data2.section24=Section24Update;
      this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned ? this.data2.section24.self_occupied.total_planned*(-1) : 0;
    },
    saveplan() {
      this.showConfirmationMsg = true;
    },

    updateSelfOccupiedPlanned() {
      if (this.data2.section24 && this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned !== undefined) {
        this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0
          ? -this.data2.section24.self_occupied.total_planned
          : this.data2.section24.self_occupied.total_planned;
      }
    },

  async saveTaxRegime() {
    try {
      this.data2.plan_id=this.instance.it_plan_id;
      this.data2.employee_id=this.instance.employee_id;
      this.data2.financial_year=this.instance.financial_year;
      this.data2.le_id=this.instance.le_id;
      this.data2.month = this.payrollMonth.substring(0,3).toLowerCase();
      this.data2.isEmployee = 'false'
      await this.updateSelfOccupiedPlanned();
      // this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0 ? -this.data2.section24.self_occupied.total_planned : this.data2.section24.self_occupied.total_planned;
      this.showConfirmationMsg = false;
      let res = await this.act_save_it_plan(this.data2);
      if(res && res.data && res.data.payload && !res.data.payload[0] != ''){
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: this.data2.employee_id }
        });
      } else {  
        this.logMessage = 'Failed';
        this.showErrorPopup = true;
        this.logSheetUrl = res.data.payload;
      }
    } catch (error) {
      console.log(error);
      this.errmsg = error;
        this.toast = true;
    }
      
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
    },

    //cancel() {
      //this.$router.push({
        //path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
      //});
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
      // });
    //},

    nothing() {
     //alert("Helloooo");  
    },

    popupMessage() {
      this.exemptionSection =  "Add House on Rent";
      //location.reload();
    },

    changeHeaderTitle() {
      this.exemptionSection = "Exemption Under Section 10";
      this.showPopupExemptionUnderSectionDeduction = false;
    },

    goBack() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      });
      this.showSuccessMsg = false;
    },

    async saveEssIT() {
      this.data2.plan_id=this.instance.it_plan_id;
      this.data2.employee_id=this.instance.employee_id;
      //this.data2.financial_year=this.instance.financial_year;
      this.data2.le_id=this.instance.le_id;
      this.instance.financial_year=2020;
      this.data2.regime_type = "oldregime";
      let res = await this.act_save_it_plan(this.data2);
      if(res.status){
        this.showSuccessMsg = true;
      //   this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
      //   query: { id: this.data2.employee_id }
      // });
      }else{
        //console.log("make mistake try again...........");
      }
    },
  
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center{
  margin: 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 50px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}

.img-user {
    margin-right: 10px;
    position: absolute;
}

.month {
    position: relative;
    margin-left: 40%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

#example .col-4 {
  border: 1px solid #c9c9c9;
}

#example .col-4:not(:last-child) {
  border-right-width: 0;
}

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
    height: 210px;
    padding: 32px;
    border-radius: 10px 0px 0px 10px;
    border: solid 1px #dddddd;
}    

.middle {
    max-width:37%;
    height: 210px;
    padding: 32px;
    // border-radius: 10px 0px 0px 10px;
    // border: solid 1px #dddddd;
}

.last {
    max-width: 37%;
    flex: 0 0 37%;
    height: 210px;
    padding: 32px;
    border-radius: 0px 10px 10px 0px;
    border: solid 1px #dddddd;
}

.view-salary-breakup {
  margin: 22px 0px 0px 0px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
  cursor: pointer;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color:#ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}



  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    //padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 20px;
      line-height: 25px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  padding:0 30px 30px;
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
.top-bar {
  height: 64px;
  width: 100%;
  //width: 453px;
  //transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

// ESS UI part CSS
.income-tax-summary-box  {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: 'Montserrat';
}

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.back-btn-color-text {
  color: #40C6BF;
  font-weight: 600;
  text-align: center;
  margin: 12px 0px 0px;
  cursor: pointer;
}

.custom-col-3 {
  background: white;
  padding: 16px;
  margin: 5px;
  flex: 0 0 22%;  // 24% change to 22%
  max-width: 22%; // 24% change to 22%
  border-radius: 8px;
}

.sm-text-it-summary {
  color: #8d8d8d;
  font-size: 1.0rem;
  font-weight: 500;
  font-family: 'Montserrat';
}

.sm-sub-text-it-summary {
  font-weight: 600;
  margin-top: 8px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.sm-sub-text-right {
  font-family: 'Montserrat';
  font-size: 0.8rem;
}

// .add-btn-sm {
//   margin-top: 5px;
// }

.change-btn-color-text {
  border: #34C0BD solid 1px;
  background: #34C0BD;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: 6px;
  cursor: pointer;
}

.col-bg-gray {
  background: #ebebeb;
  padding: 15px;
  border-radius: 8px;
}

.img-block {
  margin-top: 6px;
}

.heading-text {
  font-size: 1.125rem;
  font-weight: bold;
  color: #40C6BF;
  margin-bottom: 9px;
  font-family: 'Montserrat';
}

.sub-heading-details-sm {
  color: #8d8d8d;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: 'Montserrat';
}

.total-amount-text {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 14px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.arrow-icon-it {
  position: relative;
  top: calc(50% - 10px);
}

.arrow-left-align {
  text-align: end;
  cursor: pointer;
}

.cursor-point {
  cursor: pointer;
}
</style>
